export default __webpack_public_path__ + "static/media/IMG_3018.2ac6378a.jpeg";